import { Injectable } from '@angular/core';
import { CONFIGURATION } from "../app.config";
import { Observable } from "rxjs/Observable";
import { Http, Response, Headers, RequestOptions } from "@angular/http";

@Injectable()
export class ForgotpasswordService {

  private _AuthUrl = CONFIGURATION.baseAuthURL;

  constructor(private _http: Http) { }

  postemail(newvalues: any): Observable<any> {
    const headers = new Headers();
    const options = new RequestOptions({ headers: headers });
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._AuthUrl + '/generate-otp', newvalues, { headers: headers })
      .map((res: Response) => {return res})
      .catch(this.handleError);
  }
  postOtp(newvalues: any): Observable<any> {
    const headers = new Headers();
    const options = new RequestOptions({ headers: headers });
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    headers.append('Content-Type', 'application/json');
    console.log(headers);
    return this._http.post(this._AuthUrl + '/validate-otp', newvalues, { headers: headers })
      .map((res: Response) => {
        return res
      })
      .catch(this.handleError);
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.service.ts